"use client";

import { Sparkles, Mail, Phone, MapPin, Heart } from "lucide-react";

interface SoftFooterProps {
  subdomain: string;
  storeName?: string;
  phone?: string;
}

export default function SoftFooter({ subdomain, storeName, phone }: SoftFooterProps) {
  return (
    <footer className="bg-white border-t border-slate-100 pt-16 pb-8 font-sans text-slate-600 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Brand Info */}
        <div className="space-y-3">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-2xl bg-blue-600 text-white flex items-center justify-center font-black">
              <Sparkles className="w-5 h-5" />
            </div>
            <span className="font-black text-xl text-slate-900 capitalize">
              {storeName || subdomain}<span className="text-blue-600">.</span>
            </span>
          </div>
          <p className="text-xs text-slate-500 leading-relaxed">
            The next-generation classified e-commerce platform delivering authentic products right to your door.
          </p>
        </div>

        {/* Navigation */}
        <div>
          <h4 className="font-black text-sm text-slate-900 mb-3">Quick Navigation</h4>
          <ul className="space-y-2 text-xs font-medium">
            <li><a href="#categories" className="hover:text-blue-600">All Categories</a></li>
            <li><a href="#featured" className="hover:text-blue-600">Featured Items</a></li>
            <li><a href="#deals" className="hover:text-blue-600">Deals of the Day</a></li>
          </ul>
        </div>

        {/* Customer Care */}
        <div>
          <h4 className="font-black text-sm text-slate-900 mb-3">Customer Support</h4>
          <ul className="space-y-2 text-xs font-medium">
            <li><a href="#faq" className="hover:text-blue-600">Help & FAQs</a></li>
            <li><span className="cursor-pointer hover:text-blue-600">Track Order</span></li>
            <li><span className="cursor-pointer hover:text-blue-600">Return Policy</span></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="space-y-2.5 text-xs">
          <h4 className="font-black text-sm text-slate-900 mb-3">Contact Store</h4>
          <p className="flex items-center gap-2 text-slate-500">
            <MapPin className="w-4 h-4 text-blue-600 flex-shrink-0" />
            <span>Dhaka, Bangladesh</span>
          </p>
          <p className="flex items-center gap-2 text-slate-500">
            <Phone className="w-4 h-4 text-blue-600 flex-shrink-0" />
            <span>{phone || "+880 1700-000000"}</span>
          </p>
          <p className="flex items-center gap-2 text-slate-500">
            <Mail className="w-4 h-4 text-blue-600 flex-shrink-0" />
            <span>support@{subdomain}.com</span>
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 mt-12 pt-6 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-400 gap-4">
        <p>© {new Date().getFullYear()} {storeName || subdomain}. All rights reserved.</p>
        <p className="flex items-center gap-1">
          Built with <Heart className="w-3.5 h-3.5 text-rose-500 fill-rose-500" /> on XyloSaaS Platform
        </p>
      </div>
    </footer>
  );
}